import { render, staticRenderFns } from "./energyDetail.vue?vue&type=template&id=4a89ba7a&scoped=true"
import script from "./energyDetail.vue?vue&type=script&lang=js"
export * from "./energyDetail.vue?vue&type=script&lang=js"
import style0 from "./energyDetail.vue?vue&type=style&index=0&id=4a89ba7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89ba7a",
  null
  
)

export default component.exports